<template>
  <div class="text-brand-black-secondary">
    <FilevaliditySkeleton v-if="isLoading"></FilevaliditySkeleton>
    <template v-else>
      <Form
        :keep-values="true"
        :initial-values="initialValues"
        class="w-full md:w-1/2 flex flex-col gap-y-5"
        v-slot="{ errors, values, resetForm, setFieldValue }"
      >
        <fieldset class="border-2 border-primary rounded p-4 flex flex-col gap-y-5">
          <legend class="px-4 text-xl">{{ $t('issueQRCode') }}</legend>
          <div class="flex gap-x-4">
            <span>{{ $t('verifyBy') }}</span>
            <div class="flex gap-x-6">
              <Field :value="1" name="verifyByMobileNumber" type="radio" v-slot="{ field }">
                <label class="flex gap-x-2">
                  <input class="accent-primary" type="radio" v-bind="field" />
                  {{ $t('mobileNumber') }}
                </label>
              </Field>
              <Field :value="0" name="verifyByMobileNumber" type="radio" v-slot="{ field }">
                <label class="flex gap-x-2">
                  <input class="accent-primary" type="radio" v-bind="field" />
                  {{ $t('personalInfo') }}
                </label>
              </Field>
            </div>
          </div>
          <MobileForm v-if="values.verifyByMobileNumber === 1" />
          <PersonalInfoForm v-else />
        </fieldset>
      </Form>
    </template>
  </div>
</template>

<script setup>
import MobileForm from '@/views/addl-service-form/issue-qr-code/MobileForm.vue'
import PersonalInfoForm from '@/views/addl-service-form/issue-qr-code/PersonalInfoForm.vue'
import FilevaliditySkeleton from '@/views/file-validity/skeleton.vue'
import { Field, Form } from 'vee-validate'
import { ref } from 'vue'

const isLoading = ref(false)

const initialValues = {
  verifyByMobileNumber: 1,
  isByUnifiedNumber: 1
}

// const form = computed(() => {})
</script>

<style lang="scss" scoped></style>
